var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnsubscribe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#FDE8A9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3529 33.2107L19.2487 24.8472V42.5763H34.1258C34.1258 42.9361 34.158 43.3279 34.2222 43.7519C34.2864 44.1758 34.3699 44.5548 34.4727 44.8888H19.2487C18.6321 44.8888 18.0925 44.6512 17.63 44.1758C17.1675 43.7005 16.9362 43.1673 16.9362 42.5763V22.5347C16.9362 21.9437 17.1675 21.4105 17.63 20.9352C18.0925 20.4598 18.6321 20.2222 19.2487 20.2222H45.4571C46.0481 20.2222 46.5812 20.4598 47.0566 20.9352C47.5319 21.4105 47.7696 21.9437 47.7696 22.5347V33.7503C47.4869 33.5961 47.1208 33.4484 46.6711 33.3071C46.2215 33.1657 45.8168 33.0565 45.4571 32.9795V24.8472L32.3529 33.2107ZM32.3529 30.744L45.4571 22.5347H19.2487L32.3529 30.744ZM43.6456 49.5138C41.6516 49.5138 39.9519 48.8201 38.5465 47.4326C37.141 46.0451 36.4383 44.3491 36.4383 42.3445C36.4383 40.34 37.141 38.6313 38.5465 37.2185C39.9519 35.8057 41.6516 35.0993 43.6456 35.0993C45.6396 35.0993 47.3394 35.8057 48.7448 37.2185C50.1502 38.6313 50.8529 40.34 50.8529 42.3445C50.8529 44.3491 50.1502 46.0451 48.7448 47.4326C47.3394 48.8201 45.6396 49.5138 43.6456 49.5138ZM39.2904 42.9618H48.0008V41.4201H39.2904V42.9618Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(13.8529 14.0554)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribe);
export default __webpack_public_path__ + "static/media/unsubscribe.c5c87be2995733f1e9af055a78477ad8.svg";
export { ForwardRef as ReactComponent };